export const tableCustomStyles = {
  table: {
    style: {
      backgroundColor: "transparent",
    },
  },
  headRow: {
    style: {
      backgroundColor: "transparent",
      borderBottom: "none",
      minHeight: "48px",
    },
  },
  headCells: {
    style: {
      fontWeight: "700",
      fontSize: "0.78rem",
      letterSpacing: "0.04em",
      textTransform: "uppercase",
      background: "linear-gradient(135deg, #2980B9 0%, #34495E 100%)",
      color: "#ffffff",
      paddingTop: "14px",
      paddingBottom: "14px",
      justifyContent: "center",
      textAlign: "center",
    },
  },
  rows: {
    style: {
      minHeight: "52px",
      backgroundColor: "#ffffff",
      borderBottom: "1px solid rgba(41, 128, 185, 0.1)",
      transition: "background-color 0.15s ease",
    },
    highlightOnHoverStyle: {
      backgroundColor: "rgba(41, 128, 185, 0.08)",
      borderBottomColor: "rgba(41, 128, 185, 0.18)",
    },
    stripedStyle: {
      backgroundColor: "#f8fafc",
    },
  },
  cells: {
    style: {
      fontSize: "0.875rem",
      color: "#34495E",
      paddingTop: "12px",
      paddingBottom: "12px",
      justifyContent: "center",
      textAlign: "center",
    },
  },
  pagination: {
    style: {
      borderTop: "1px solid rgba(41, 128, 185, 0.12)",
      backgroundColor: "#f4f8fb",
      minHeight: "52px",
      color: "#34495E",
      fontSize: "0.85rem",
    },
    pageButtonsStyle: {
      borderRadius: "0.5rem",
      height: "2rem",
      minWidth: "2rem",
      padding: "0 0.35rem",
      margin: "0 2px",
      color: "#34495E",
      fill: "#34495E",
      transition: "all 0.15s ease",
    },
  },
  noData: {
    style: {
      padding: "2rem 1rem",
      color: "#5f6f7f",
      backgroundColor: "#f8fafc",
    },
  },
};

const mergeStyleSection = (base = {}, override = {}) => ({
  ...base,
  ...override,
  style: { ...(base.style || {}), ...(override.style || {}) },
});

export const mergeTableStyles = (override = {}) => ({
  table: mergeStyleSection(tableCustomStyles.table, override.table),
  headRow: mergeStyleSection(tableCustomStyles.headRow, override.headRow),
  headCells: mergeStyleSection(tableCustomStyles.headCells, override.headCells),
  rows: {
    ...tableCustomStyles.rows,
    ...override.rows,
    style: { ...tableCustomStyles.rows?.style, ...override.rows?.style },
    highlightOnHoverStyle: {
      ...tableCustomStyles.rows?.highlightOnHoverStyle,
      ...override.rows?.highlightOnHoverStyle,
    },
    stripedStyle: {
      ...tableCustomStyles.rows?.stripedStyle,
      ...override.rows?.stripedStyle,
    },
  },
  cells: mergeStyleSection(tableCustomStyles.cells, override.cells),
  pagination: {
    ...tableCustomStyles.pagination,
    ...override.pagination,
    style: { ...tableCustomStyles.pagination?.style, ...override.pagination?.style },
    pageButtonsStyle: {
      ...tableCustomStyles.pagination?.pageButtonsStyle,
      ...override.pagination?.pageButtonsStyle,
    },
  },
  noData: mergeStyleSection(tableCustomStyles.noData, override.noData),
});
